import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationHttpClient } from '../../shared/api/application-http-client';
import { Orientation } from '../orientation-video/orientation'

@Injectable()
export class OrientationVideoService {

    constructor(private httpClient: ApplicationHttpClient) { }

    getOrientationVideos(): Observable<Orientation> {
        return this.httpClient.get(`/orientationVideo`).pipe(
            map((orientation: Orientation) => {
                return orientation;
            }));
    }
}
